import React from "react";
import { Input } from "./_shared";
import { api, resolveUrl, formatApiError } from "../../../lib/api";

export default function AppearanceTab({ settings, setSettings, load, flash, saveHero, uploadHeroImage, saveFloating }) {
  const saveQuoteToggle = async () => {
    try {
      await api.put("/admin/settings", { quote_form_enabled: settings.quote_form_enabled !== false });
      await load();
      flash("Setare formular salvata ✓");
    } catch (e) {
      flash("Eroare: " + formatApiError(e));
    }
  };

  return (
    <>
      {/* Quote form toggle */}
      <section className="card-surface p-5 sm:p-8 mb-6" data-testid="quote-form-toggle-section">
        <h2 className="font-serif text-xl sm:text-2xl mb-2">Sectiunea "Cere oferta personalizata"</h2>
        <p className="text-xs mb-4" style={{ color: "var(--brand-text-secondary)" }}>
          Formularul vizibil pe pagina principala unde clientii cer o oferta. Daca dezactivezi, intreaga sectiune dispare de pe site.
        </p>
        <label className="flex items-center gap-3 cursor-pointer" data-testid="quote-form-toggle-label">
          <input
            type="checkbox"
            checked={settings.quote_form_enabled !== false}
            onChange={(e) => setSettings({ ...settings, quote_form_enabled: e.target.checked })}
            className="w-4 h-4"
            data-testid="quote-form-toggle"
          />
          <span className="text-sm">Afiseaza sectiunea "Cere oferta personalizata" pe homepage</span>
        </label>
        <button onClick={saveQuoteToggle} className="btn-gold-filled mt-4" data-testid="save-quote-form-toggle">
          Salveaza
        </button>
      </section>

      {/* Hero */}
      <section className="card-surface p-5 sm:p-8 mb-6" data-testid="hero-section-admin">
        <h2 className="font-serif text-xl sm:text-2xl mb-2">Sectiunea Hero</h2>
        <p className="text-xs mb-2" style={{ color: "var(--brand-text-secondary)" }}>Imaginea de fundal, eyebrow, titlu, subtitlu si CTA care apar in prima sectiune a paginii principale.</p>
        <p className="text-[11px] mb-6 italic" style={{ color: "var(--brand-text-secondary)" }}>💡 Daca lasi un camp gol, pe site apare valoarea default afisata ca placeholder mai jos.</p>

        <div className="grid sm:grid-cols-2 gap-4 mb-6">
          <Input label="Eyebrow RO" value={settings.hero?.eyebrow_ro || ""} placeholder="Pascani · Romania" onChange={(v) => setSettings({...settings, hero: {...(settings.hero||{}), eyebrow_ro: v}})} testid="hero-eyebrow-ro" />
          <Input label="Eyebrow EN" value={settings.hero?.eyebrow_en || ""} placeholder="Pascani · Romania" onChange={(v) => setSettings({...settings, hero: {...(settings.hero||{}), eyebrow_en: v}})} testid="hero-eyebrow-en" />
          <Input label="Titlu RO" value={settings.hero?.title_ro || ""} placeholder="Eleganta in miscare" onChange={(v) => setSettings({...settings, hero: {...(settings.hero||{}), title_ro: v}})} testid="hero-title-ro" />
          <Input label="Titlu EN" value={settings.hero?.title_en || ""} placeholder="Elegance in motion" onChange={(v) => setSettings({...settings, hero: {...(settings.hero||{}), title_en: v}})} testid="hero-title-en" />
          <Input label="Subtitlu RO" value={settings.hero?.subtitle_ro || ""} placeholder="Inchiriaza masini premium in Pascani..." onChange={(v) => setSettings({...settings, hero: {...(settings.hero||{}), subtitle_ro: v}})} testid="hero-subtitle-ro" />
          <Input label="Subtitlu EN" value={settings.hero?.subtitle_en || ""} placeholder="Rent premium cars in Pascani..." onChange={(v) => setSettings({...settings, hero: {...(settings.hero||{}), subtitle_en: v}})} testid="hero-subtitle-en" />
          <Input label="Buton CTA — text RO" value={settings.hero?.cta_label_ro || ""} placeholder="Exploreaza colectia" onChange={(v) => setSettings({...settings, hero: {...(settings.hero||{}), cta_label_ro: v}})} testid="hero-cta-ro" />
          <Input label="Buton CTA — text EN" value={settings.hero?.cta_label_en || ""} placeholder="Explore collection" onChange={(v) => setSettings({...settings, hero: {...(settings.hero||{}), cta_label_en: v}})} testid="hero-cta-en" />
          <Input label="Buton CTA — link (ex. #fleet sau /reviews)" value={settings.hero?.cta_href || ""} placeholder="#fleet" onChange={(v) => setSettings({...settings, hero: {...(settings.hero||{}), cta_href: v}})} testid="hero-cta-href" />
        </div>

        <div className="mb-6">
          <label className="label-eyebrow block mb-2">Imagine de fundal hero (1600x900 recomandat)</label>
          <div className="flex items-center gap-3">
            {settings.hero?.image_path && (
              <img src={resolveUrl(settings.hero.image_path)} alt="Hero" className="h-20 w-32 object-cover rounded" data-testid="hero-image-preview" />
            )}
            <input type="file" accept="image/png,image/jpeg,image/webp" onChange={(e) => e.target.files?.[0] && uploadHeroImage(e.target.files[0])} className="text-xs" data-testid="hero-image-upload" />
          </div>
        </div>

        <button onClick={saveHero} className="btn-gold-filled" data-testid="save-hero">Salveaza hero</button>
      </section>

      {/* Floating contact buttons */}
      <section className="card-surface p-5 sm:p-8" data-testid="floating-section">
        <h2 className="font-serif text-xl sm:text-2xl mb-2">Butoane flotante (WhatsApp / Suna)</h2>
        <p className="text-xs mb-6" style={{ color: "var(--brand-text-secondary)" }}>Activeaza sau dezactiveaza butoanele care apar in coltul dreapta-jos pe paginile publice.</p>
        <div className="flex flex-col gap-3 mb-6">
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={settings.floating_contact?.whatsapp_enabled !== false} onChange={(e) => setSettings({...settings, floating_contact: {...(settings.floating_contact||{}), whatsapp_enabled: e.target.checked}})} data-testid="fc-whatsapp" />
            Buton WhatsApp activ
          </label>
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={settings.floating_contact?.call_enabled !== false} onChange={(e) => setSettings({...settings, floating_contact: {...(settings.floating_contact||{}), call_enabled: e.target.checked}})} data-testid="fc-call" />
            Buton "Suna acum" activ
          </label>
        </div>
        <button onClick={saveFloating} className="btn-gold-filled" data-testid="save-floating">Salveaza</button>
      </section>
    </>
  );
}
